export default __webpack_public_path__ + "static/media/rusbath1.728ca278.jpeg";